import { createSelector } from 'reselect'

export const selectSidebar = (s: any) => s.sidebar

export const selectSidebarIsOpen = createSelector(
  selectSidebar,
  (sidebar) => sidebar.isOpen
)
